<template>
  <div>
    <LabelHeader msg="项目管理"></LabelHeader>

    <div style="padding: 20px 0 0 0; display: flex">
      <el-form :inline="true">
        <el-form-item label="项目名称"
          ><el-input size="small" type="text" v-model="searchParams.name"
        /></el-form-item>
        <el-form-item label="状态">
          <!-- <el-input size="small" type="text" v-model="searchParams.status"/> -->
          <el-select v-model="searchParams.status" placeholder="请选择项目状态">
            <el-option label="进行中" :value="2"></el-option>
            <el-option label="未开始" :value="1"></el-option>
            <el-option label="已完结" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div>
            <el-button type="primary" size="mini" @click="search()">
              查询</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
    <LabelHeader msg="查询结果"></LabelHeader>
    <div class="buttonBox">
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-circle-plus-outline"
        @click="editDialogVisible = true"
        >新增
      </el-button>
    </div>
    <el-table
      ref="table"
      :data="items"
      border
      stripe
      :cell-style="{ padding: '0px' }"
      :header-row-style="{ height: '35px' }"
      :header-cell-style="{
        padding: '0px',
        background: '#f5f7fa',
        color: '#606266',
      }"
      :row-style="{ height: '35px' }"
    >
      <af-table-column
        prop="name"
        label="名称"
        align="center"
      ></af-table-column>
      <af-table-column
        prop="code"
        label="编码"
        align="center"
      ></af-table-column>
      <af-table-column
        prop="leaderName"
        label="负责人"
        align="center"
      ></af-table-column>
      <af-table-column
        prop="status"
        label="状态"
        align="center"
        :formatter="formatStatus"
      ></af-table-column>
      <af-table-column
        prop="budget"
        label="预算成本(元)"
        align="center"
        :width="200"
      ></af-table-column>
      <af-table-column
        prop="consume"
        label="消耗成本(元)"
        align="center"
        :width="200"
      ></af-table-column>
      <af-table-column
        prop="surplus"
        label="结余成本(元)"
        align="center"
        :width="200"
      >
        <template slot-scope="scope">
          {{ (scope.row.budget - scope.row.consume).toFixed(2) }}
        </template>
      </af-table-column>
      <af-table-column
        prop="createAt"
        label="创建时间"
        align="center"
      ></af-table-column>
      <af-table-column label="操作" align="center" :width="200">
        <template slot-scope="scope">
          <el-link
            type="primary"
            size="mini"
            :underline="false"
            @click="openDetailDialog(scope.row)"
            >修改</el-link
          >
          <!-- <router-link
              :to="{ path: '/pms_statistics', query: { index: scope.row } }"
              >统计</router-link
            > -->
          <el-button @click="itemList(scope.row)" type="text">明细</el-button>
          <el-button
            @click="statisticsList(scope.row)"
            type="text"
            style="margin-left: 0"
            >统计</el-button
          >
        </template>
      </af-table-column>
    </el-table>
    <el-pagination
      @size-change="handlePageSizeChange"
      @current-change="handlePageNoChange"
      :current-page="pageInfo.pageNo"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.totalItems"
    >
    </el-pagination>
    <!--                <Pagination v-if="pagination.total>0" layout="sizes,pager,jumper,total" v-model="pagination"-->
    <!--                            @change="refresh"></Pagination>-->
    <el-dialog
      title="新增项目"
      :visible.sync="editDialogVisible"
      v-if="editDialogVisible"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        :rules="rules"
      >
        <el-form-item label="部门名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="code">
          <el-input v-model="ruleForm.code"></el-input>
        </el-form-item>
        <!-- <el-form-item label="负责人" prop="leaderName">
                    <el-select v-model="ruleForm.leaderName" placeholder="请选择该项目负责人">
                      <el-option label="总经理" value="总经理"></el-option>
                      <el-option label="产品经理" value="总经理"></el-option>
                    </el-select> -->
        <el-form-item label="负责人" prop="leaderName">
          <el-input v-model="ruleForm.leaderName"></el-input>
        </el-form-item>
        <el-form-item label="预算成本" prop="budget">
          <el-input v-model="ruleForm.budget"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status">
            <el-radio :label="1">未开始</el-radio>
            <el-radio :label="2">进行中</el-radio>
            <el-radio :label="3">已完结</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-col :span="11">
            <el-form-item prop="createAt">
              <el-date-picker
                type="datetime"
                placeholder="选择日期"
                v-model="ruleForm.createAt"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确认</el-button
          >
          <el-button @click="closeFrom()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--                <button v-if="pagination.total>0" @click="refresh" class="h-btn h-btn-text  hover-text"-->
    <!--                        style="font-size: 16px;height: 30px">-->
    <!--                    <i :class="refreshing? 'h-icon-spinner': 'h-icon-refresh'"></i>-->
    <!--                </button>-->

    <el-dialog
      title="修改项目"
      :visible.sync="detailDialogVisible"
      v-if="detailDialogVisible"
    >
      <Detail :project="this.currentProject"></Detail>
    </el-dialog>
    <el-dialog
      fullscreen
      title="项目明细"
      :visible.sync="detailDialogVisible1"
      v-if="detailDialogVisible1"
    >
      <DetailItem :projectCode="this.projectCode"></DetailItem>
    </el-dialog>
    <el-dialog
      fullscreen
      title="项目统计"
      :visible.sync="detailDialogVisible2"
      v-if="detailDialogVisible2"
    >
      <projectItem :projectList="projectList"></projectItem>
    </el-dialog>
  </div>
</template>

<script>
import LabelHeader from "../../../eap/components/LabelHeader";
import Edit from "./edit";
import Detail from "./detail";
import DetailItem from "./detailItem";
import projectItem from "../statistics/project";
import jsonKit from "../../../../dxrj.sdk/js/kit/jsonKit";

export default {
  data() {
    return {
      param: [
        { name: "是", code: "yes" },
        { name: "否", code: "no" },
      ],
      items: [], // 数据集合
      searchParams: {
        status: "",
        // 查询参数
        driverClass: "",
        jdbcUrl: "",
        name: "",
        userName: "",
        password: "",
        type: "",
      },
      currentRowDataId: "",
      currentProject: "",
      idParam: "",
      pageInfo: { pageNo: 1, pageSize: 10, totalItems: 0, totalPages: 0 }, // 分页参数
      refreshing: false, // 结果列表是否正在刷新
      editDialogVisible: false, // 编辑窗口是否可见
      ruleForm: {
        name: "",
        code: "",
        leaderName: "",
        status: 2,
        budget: "",
        consume: "0",
        createAt: new Date(),
      },
      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        code: [{ required: true, message: "请输入编码", trigger: "blur" }],
        leaderName: [
          {
            required: true,
            message: "请输入负责人",
            trigger: "blur",
          },
        ],
        budget: [
          {
            required: true,
            message: "请输入预算成本",
            trigger: "blur",
          },
        ],
        createAt: [
          {
            type: "date",
            required: true,
            message: "请选择开始时间",
            trigger: "change",
          },
        ],
      },
      detailDialogVisible: false, // 详情窗口是否可见
      detailDialogVisible1: false, // 详情窗口是否可见
      detailDialogVisible2: false, // 详情窗口是否可见
      projectCode: null,
      projectList: {},
    };
  },
  components: { Edit, Detail, LabelHeader, DetailItem, projectItem },
  computed: {},
  // 页面加载获取数据
  mounted() {
    this.refresh();
  },
  watch: {},
  methods: {
    itemList(scope) {
      this.projectCode = scope.code;
      this.detailDialogVisible1 = true;
    },
    statisticsList(scope) {
      this.projectList = scope;
      this.detailDialogVisible2 = true;
    },
    closeFrom() {
      this.editDialogVisible = false;
      this.reset();
    },
    reset() {
      this.ruleForm = {
        name: "",
        code: "",
        leaderName: "",
        status: 2,
        budget: "",
        consume: "0",
        createAt: new Date(),
      };
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          httpKit.post($api_pms.project.save, this.ruleForm).then((res) => {
            if (res.data.code === "200") {
              this.$message({
                message: "新增成功",
                type: "success",
              });
              this.editDialogVisible = false;
              this.reset();
              this.refresh();
            } else if (res.data.code === "500") {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    handlePageSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageInfo.pageSize = val;
      this.search();
    },
    handlePageNoChange(val) {
      console.log(`当前页: ${val}`);
      this.pageInfo.pageNo = val;
      this.search();
    },
    formatStatus(row) {
      return row.status === 2
        ? "进行中"
        : row.status === 1
        ? "未开始"
        : "已完结";
    },
    refresh() {
      this.refreshing = true;
      this.search();
    },
    search() {
      httpKit
        .post(
          $api_pms.project.search,
          jsonKit.extend(this.searchParams, this.pageInfo, true)
        )
        .then((res) => {
          // this.refreshing = false;
          console.log(res);
          if (res.data.code === "200") {
            console.log("ok");
            this.items = res.data.data;
            this.pageInfo.totalItems = res.data.totalItems;
          } else if (res.data.code === "500") {
            this.items = [];
            console.log("err");
            // this.$Message.error(res.data.msg);
          }
        });
    },
    deleteBatch() {
      let selection = this.$refs.table.getSelection();
      if (selection.length <= 0) {
        this.$Message.error("请选择最少一条记录");
        return;
      }
      this.$Confirm("您确定要删除这条记录吗？")
        .then(() => {
          let idAryStr = (parameter = selection[0].id);
          for (let i = 1; i < selection.length; i++) {
            idAryStr += "," + selection[i].id;
          }
          jsKit
            .delete({ ids: idAryStr }, $api_pms.message.delete)
            .then((res) => {
              this.deleteCallback(res);
            });
        })
        .catch((error) => {
          this.$Message.error("取消");
        });
    },
    deleteItem(idVal) {
      this.$Confirm("您确定要删除这条记录吗？")
        .then(() => {
          jsKit.delete($api_pms.message.delete, idVal).then((res) => {
            this.deleteCallback(res);
          });
        })
        .catch((error) => {
          this.$Message.error("取消");
        });
    },
    openEditDialog(idVal) {
      this.editDialogVisible = true;
      this.idParam = idVal;
    },
    openDetailDialog(rowData) {
      this.currentProject = rowData;
      this.detailDialogVisible = true;
      // this.$router.push({ path: '/projectDetail', query: { id: this.idParam } });
    },
    deleteCallback(res) {
      if (res.data.code === "200") {
        this.$Message.error("删除成功");
        this.refresh();
      } else if (res.data.code === "500") {
        this.$Message.error("删除失败:" + res.data.msg);
      }
    },
    closeCallback() {
      this.editDialogVisible = false;
      this.detailDialogVisible = false;
      this.detailDialogVisible1 = false;
    },
    refreshCallback() {
      this.closeCallback();
      this.search();
    },
  },
};
</script>

<style lang="less" scoped>
</style>
